<app-page-header [title]="'Afas nacalculatie'" subtitle="Periode {{ period }} - {{ year }}">
    <div class="d-flex align-items-center" filters>
        <div class="mt-1 ms-2 d-flex">
            <mat-radio-group class="d-flex" [formControl]="fcType">
                <mat-radio-button class="me-3" value="entities">Materieel</mat-radio-button>
                <mat-radio-button class="me-3" value="users">Medewerkers</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    <app-date-indicator [fromDate]="beginDate" [toDate]="endDate" (next)="next()" (prev)="prev()" indicator>
    </app-date-indicator>
</app-page-header>
<div class="wrapper">
    <div class="container-xl">
        <div class="mb-1 d-flex align-items-center">
            @if (fcAfasProjectId.value) {
                <button
                    class="me-2"
                    mat-raised-button
                    color="primary"
                    routerLink="/settlements/{{ period }}/{{ year }}/{{ fcType.value }}">
                    Terug naar overzicht
                </button>
            }
            @if (fcAfasProjectId.value) {
                <div class="pr-3">Project: {{ fcAfasProjectId.value }}</div>
            }
            @if (total) {
                <div>
                    Totaal <b>{{ total }}</b> waarvan <b>{{ totalSend }}</b> verstuurd en
                    <b>{{ totalError }}</b> mislukt
                </div>
            }
            <div class="flex-fill"></div>
            @if (settlementCounts?.length && settlementCounts[0]?.retrying > 0) {
                <div>Verzenden...</div>
            }
            @if (fcAfasProjectId.value && settlementCounts && (totalError > 0 || total > totalSend)) {
                <button
                    (click)="$event.stopPropagation(); retrySendingSettlements(settlementCounts[0])"
                    mat-icon-button
                    color="primary">
                    <mat-icon
                        class="fa-solid fa-repeat curpoint"
                        [class.fa-fade]="settlementCounts[0].retrying > 0"
                        matTooltip="Alle niet verzonden en mislukte regels opnieuw verzenden"></mat-icon>
                </button>
            }
            @if (fcAfasProjectId.value && total !== totalSend) {
                <button (click)="editProject(this.settlements)" mat-raised-button color="primary">
                    Project aanpassen
                </button>
            }
        </div>
        @if (!fcAfasProjectId.value) {
            <table class="table table-hover table-last-col">
                <tr>
                    <th class="project">Project</th>
                    <th></th>
                    <th class="text-right" [style.width.px]="85">Aantal</th>
                    <th class="text-right" [style.width.px]="90">Verstuurd</th>
                    <th class="text-right" [style.width.px]="90">Mislukt</th>
                    <th></th>
                </tr>
                @for (count of settlementCounts; track count) {
                    <tr [class.error]="count.error_count > 0">
                        <td
                            class="curpoint"
                            matRipple
                            routerLink="/settlements/{{ period }}/{{ year }}/{{ fcType.value }}/{{
                                count.afas_project_id ?? 'no-project'
                            }}">
                            {{ count.afas_project_id ?? 'Geen project' }}
                        </td>
                        <td>
                            {{ count.project_name }}
                        </td>
                        <td class="text-right">
                            {{ count.settlement_count }}
                        </td>
                        <td class="text-right" [class.error]="count.sent_count != count.settlement_count">
                            {{ count.sent_count }}
                        </td>
                        <td>
                            {{ count.error_count }}
                        </td>
                        <td>
                            <div class="d-flex">
                                <div>
                                    @if (count.settlement_count > count.sent_count) {
                                        <i
                                            class="fa-solid fa-repeat curpoint"
                                            [class.fa-fade]="count.retrying > 0"
                                            (click)="$event.stopPropagation(); retrySendingSettlements(count)"
                                            matTooltip="Alle niet verzonden en mislukte regels opnieuw verzenden"></i>
                                    }
                                </div>
                            </div>
                            @if (count.retrying > 0) {
                                <small [style.font-size.px]="11"> Verzenden... </small>
                            }
                        </td>
                    </tr>
                }
                @if (!settlementCounts?.length && settlementCounts !== null) {
                    <tr>
                        <td class="text-center" colspan="5">Geen Afas nacalculatieregels gevonden</td>
                    </tr>
                }
                @if (!settlementCounts?.length && settlementCounts === null) {
                    <tr>
                        <td class="text-center" colspan="5">Bezig met laden van boekingsregels...</td>
                    </tr>
                }
            </table>
        }
        @if (fcAfasProjectId.value) {
            <table class="table table-last-col">
                <tr>
                    <th colspan="2">
                        {{ fcType.value === 'entities' ? 'Materieel' : 'Medewerker' }}
                    </th>
                    <th class="text-right">Uren</th>
                    <th [style.width.px]="125">Boekdatum</th>
                    <th>Uurtype</th>
                    <th>Foutmelding</th>
                    <th>Verstuurd</th>
                    <th>Afas ID</th>
                    <th></th>
                </tr>
                @for (settlement of settlements; track settlement) {
                    <tr [class.error]="settlement.afas_error">
                        <td>
                            {{ settlement?.entity?.afas_employee_id ?? settlement?.user?.afas_employee_id }}
                        </td>
                        <td>
                            {{ settlement?.entity?.name ?? settlement?.user?.name }}
                        </td>
                        <td class="text-right">
                            {{ settlement.minutes | minutes }}
                        </td>
                        <td
                            class="curpoint"
                            [routerLink]="[
                                '/check-hours',
                                settlement.bookdate | date: 'yyyy-MM-dd',
                                { realisationId: settlement.realisation_id },
                            ]">
                            {{ settlement.bookdate | date: 'dd MMM yyyy' }}
                        </td>
                        <td>
                            {{ settlement.hourtype_code }}
                        </td>
                        <td>
                            <div class="d-flex">
                                <div class="flex-fill me-1">
                                    <small>{{ settlement.afas_error }}</small>
                                </div>
                                <div class="d-flex align-items-center">
                                    @if (settlement.afas_error) {
                                        <i
                                            class="fa-solid fa-repeat me-1 curpoint"
                                            [class.fa-fade]="settlement.sending"
                                            (click)="retrySendingSettlement(settlement)"
                                            matTooltip="Opnieuw proberen"></i>
                                    }
                                </div>
                            </div>
                            @if (settlement.sending) {
                                <div>Verzenden...</div>
                            }
                        </td>
                        <td>
                            {{ settlement.sent_to_afas | date: 'd MMM yyyy HH:mm' }}
                        </td>
                        <td>
                            {{ settlement.afas_ptrealization_id }}
                        </td>
                        <td>
                            <div class="d-flex gap-2">
                                @if (!settlement.afas_ptrealization_id) {
                                    <i
                                        class="fa-solid fa-pen curpoint"
                                        (click)="editProject([settlement])"
                                        matTooltip="Wijzig projectnummer"></i>
                                }
                                @if (settlement.user_id) {
                                    <i
                                        class="fa-solid fa-user-pen curpoint"
                                        (click)="editHours(settlement.bookdate, settlement.user_id)"
                                        matTooltip="Open urenregistratie medewerker"></i>
                                }
                                <i class="fa-solid fa-trash curpoint" (click)="deleteSettlement(settlement)"></i>
                            </div>
                        </td>
                    </tr>
                }
                @if (!settlements?.length && settlements !== null) {
                    <tr>
                        <td class="text-center" colspan="8">Geen Afas nacalculatieregels gevonden</td>
                        <td></td>
                    </tr>
                }
                @if (!settlements?.length && settlements === null) {
                    <tr>
                        <td class="text-center" colspan="8">Bezig met laden van boekingsregels...</td>
                        <td></td>
                    </tr>
                }
            </table>
        }
    </div>
</div>
